// extracted by mini-css-extract-plugin
export var quillEditor = "_it-1";
export var variable = "_it-0";